import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMN_SPACING,
  CARDS_GRID_ITEM_SIZE,
} from '@app/components/base/content-structure/cards-grid-config';
import { ListViewInfiniteChildProps } from '@app/core/list-view/ListViewInfinite';
import { EnrichedCompositionListItemDto } from '@app/modules/compose/composition.types';
import { useQueryParam } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { CompositionCard } from '../composition-card/CompositionCard';
import { CompositionsGridSkeleton } from './CompositionsGridSkeleton';

export type CompositionsGridProps = ListViewInfiniteChildProps<EnrichedCompositionListItemDto>;

/**
 * Plain grid of composition cards (no date sections).
 */
export function CompositionsGrid({ data, isLoading = false }: CompositionsGridProps) {
  const { $t } = useIntl();

  const forceSkeleton = useQueryParam('skeleton');

  if (isLoading || forceSkeleton) {
    return <CompositionsGridSkeleton />;
  }

  if (!data.length) {
    return (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {$t({
            id: 'common.noResults',
            defaultMessage: 'Sin resultados',
          })}
        </Typography>
      </Box>
    );
  }

  return (
    <CardsGrid columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}>
      {data.map((composition) => (
        <CardsGridItem size={CARDS_GRID_ITEM_SIZE} key={composition.id}>
          <CompositionCard composition={composition} />
        </CardsGridItem>
      ))}
    </CardsGrid>
  );
}
